import React, { Component } from 'react';
import moment from "moment";
import {IconButton} from "office-ui-fabric-react";

interface TotpCodeProps {
    code?: string;
}

interface TotpCodeState {
    codeChangedAt: Date,
    intervalId?: NodeJS.Timeout,
    colour: string
}

export default class TotpCode extends Component<TotpCodeProps, TotpCodeState> {

    static displayName = TotpCode.name;

    constructor(props: TotpCodeProps) {
        super(props);

        this.state = {
            codeChangedAt: new Date(),
            intervalId: undefined,
            colour: "black"
        };
    }

    async componentDidMount()
    {
        this.setState({
            intervalId: setInterval(() => {
                this.determineColour();
            },1000)
        })
    }
    
    private determineColour = () => {
        
        if(this.props.code === undefined)
        {
            this.setState({
                colour: "black"
            });
            return;
        }

        const codeAge = moment().diff(this.state.codeChangedAt, 'seconds');
        const codeLifetimePercentage = codeAge / 30;

        this.setState({
            colour: `rgb(${Math.min(codeLifetimePercentage * 255,255)},0,0`
        })
        
    } 

    componentWillUnmount()
    {
        if(this.state.intervalId)
        {
            clearInterval(this.state.intervalId)
        }
    }
    
    async componentDidUpdate(prevProps: TotpCodeProps, prevState: TotpCodeState): Promise<void>
    {
        if(this.props.code !== prevProps.code)
        {
            this.setState({
                codeChangedAt: new Date()
            });
        }
    }
    
    render() {
        
        const style = {fontSize: "3rem",color: this.state.colour};
        
        if(this.props.code === undefined)
        {
            return (<span style={style}>______</span>);
        }
        
        return (
            <div className={"flex-row flex--align-items-center"}>
               <span style={style}>{this.props.code}</span>
                <IconButton iconProps={{ iconName: "Copy"}} title="Copy to clipboard" onClick={async () => {
                    await navigator.clipboard.writeText(this.props.code!)
                }}/>
            </div>
        );
    }
}